import React from 'react';
import sIcon1 from '../../images/icons/icon_dart_board_2.svg'
import sIcon2 from '../../images/icons/icon_target.svg'
import sIcon3 from '../../images/icons/icon_user_check.svg'

const Policy = [
    {
        title: 'Our Vision',
        subTitle: 'To become a leading creative and digital agency known for impactful visuals and strong brand presence.',
        icon: sIcon1,
    },
    {
        title: 'Our Mission',
        subTitle: 'To help brands grow through high-quality content, creative storytelling, and effective digital strategies.',
        icon: sIcon2,
    },
    {
        title: 'Quality Control',
        subTitle: 'Concept planning & approval, Creative direction monitoring, Professional execution',
        icon: sIcon3,
    },


]


const PolicySection = (props) => {

    return (
        <section className="policy_section">
            <div className="container">
                <div className="row">
                    {Policy.map((policy, pitem) => (
                        <div className="col-lg-4" key={pitem}>
                            <div className="iconbox_block layout_icon_left">
                                <div className="iconbox_icon bg-secondary-subtle">
                                    <img src={policy.icon} alt="Dollar SVG Icon" />
                                </div>
                                <div className="iconbox_content">
                                    <h3 className="iconbox_title">{policy.title}</h3>
                                    <p className="mb-0">
                                        {policy.subTitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PolicySection;